import { render, staticRenderFns } from "./HouseholdCompareSnippet.vue?vue&type=template&id=00d21a7c"
import script from "./HouseholdCompareSnippet.vue?vue&type=script&lang=js"
export * from "./HouseholdCompareSnippet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports